import { connect } from "react-redux";

import Button from "@components/Button";
import { addModal } from "@store/app/actions";
import Repeat from "@components/Icons/Repeat";

const NoStoreSelected = ({ addModal }) => {
  const handleAddStoreSelectModal = (event) => {
    event.preventDefault();
    addModal("StoreSelectModal");
  };

  const handleAddAvailableStoresModal = (event) => {
    event.preventDefault();
    addModal("AvailableStoresModal");
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]">
      <div className="text-[14px] font-medium mb-[10px] lg:mb-0">
        Ridicare imediata, gratuita din magazin
        <div className="flex gap-[10px]">
          <a
            className="flex items-end text-red-brand gap-[3px] cursor-pointer"
            href="#"
            onClick={handleAddStoreSelectModal}
            rel="noopener noreferrer"
          >
            <Repeat width="18px" height="18px" />
            alege un magazin favorit
          </a>
        </div>
      </div>

      <Button
        title="Vezi stocul in magazine"
        size="small"
        variant="third"
        isOrderAgain
        onClick={handleAddAvailableStoresModal}
      />
    </div>
  );
};

export default connect(null, { addModal })(NoStoreSelected);
